// extracted by mini-css-extract-plugin
module.exports = {"product-hero-images":"MainProductHeroImages_product-hero-images__A1wnJ","product-hero-images__image":"MainProductHeroImages_product-hero-images__image__75mDC"};